export const debounce = (
  func: (...args: unknown[]) => void,
  wait: number,
  immediate: boolean = false,
) => {
  let timeout: unknown;
  return function executedFunction(...args: unknown[]) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    // eslint-disable-next-line @typescript-eslint/no-this-alias,@typescript-eslint/no-unsafe-assignment
    const context = this;

    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    const callNow = immediate && !timeout;

    clearTimeout(timeout as string | number | NodeJS.Timeout | undefined);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
};
